import { Outlet } from 'react-router-dom';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import { HeaderProvider } from '@/contexts/HeaderContext';
import { ChatProvider } from '@/contexts/ChatContext';
import { PolicyNoticeProvider } from '@/contexts/PolicyNoticeContext';
import ChatPanel from '@/components/chat/ChatPanel';
import { useAuth } from '@/hooks/useAuth';
import { useAutoCanonical } from '@/hooks/useCanonicalUrl';

export default function MainLayout() {
  useAutoCanonical();
  const { isAuthenticated } = useAuth();
  return (
    <HeaderProvider>
      {/* 規約・ポリシーの改定の告知（「確認」でよい改定）。確認するまで AI アシスタントの入口からも開く */}
      <PolicyNoticeProvider>
        <ChatProvider>
          <div className="min-h-screen flex flex-col">
            <Header />
            <main className="flex-1">
              <Outlet />
            </main>
            <Footer />
          </div>
          {/* AI チャット（ログインユーザー専用。ヘッダーとイベント画面から開く） */}
          {isAuthenticated && <ChatPanel />}
        </ChatProvider>
      </PolicyNoticeProvider>
    </HeaderProvider>
  );
}
